import React from "react";
import { Modal, Form, Input, Row, Col, Card, Button, Switch } from "antd";
import { StatutService } from "../../services/StatutService";
import Toast from "../../helpers/Toast";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { catchError } from "../../services/DaoService";
import CustomFormItem from "../utils/form/CustomFormItem";
import style from "./StatutCreateForm.module.scss";

const StatutCreateForm = ({ visible, onCreate, onCancel }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [creating, setCreating] = React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState({});

  const handleSave = (isRedirection) => {
    setCreating(true);
    form
      .validateFields()
      .then((values) => {
        StatutService.getInstance()
          .create(values)
          .then((response) => {
            Toast.success(response.message);
            form.resetFields();
            onCreate(response.data);
            if (isRedirection) {
              navigate(`/statut/${response.data.uid}`);
            }
          })
          .catch((error) => {
            const errors = error.response.data;
            if (errors.validation && Object.keys(errors?.errors).length) {
              setValidationErrors(errors.errors);
            } else {
              catchError(error);
            }
          })
          .finally(() => {
            setCreating(false);
          });
      })
      .catch(() => {
        setCreating(false);
      });
  };

  return (
    <Modal
      width={"50%"}
      open={visible}
      onCancel={onCancel}
      title="Créer un nouveau statut"
      footer={[
        <>
          <Row gutter={24}>
            <Col>
              <Button
                key="cancel"
                onClick={onCancel}
                className={style.ButtonNew}
              >
                Annuler
              </Button>
            </Col>
            <Col>
              <Button
                key="save-again"
                type="primary"
                loading={creating}
                onClick={() => handleSave(false)}
                className={style.ButtonNew}
              >
                Enregistrer et Créer
              </Button>
            </Col>
          </Row>
        </>
      ]}
    >
      <Card style={{ marginBottom: 5 }}>
        <Form
          layout="vertical"
          form={form}
          name="createStatutForm"
          initialValues={{
            enabled: 1,
          }}
        >
          <Row gutter={24}>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Nom"
                name="nom"
                rules={[{ required: true, message: "Veuillez saisir le nom!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Code"
                name="code"
                rules={[{ required: true, message: "Veuillez saisir le code!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Couleur"
                name="couleur"
                rules={[{ required: true, message: "Veuillez saisir le couleur!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="color" />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Statut"
                name="enabled"
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                valuePropName="checked"
              >
                <Switch defaultChecked checkedChildren="Actif" unCheckedChildren="Inactif" />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={24}>
              <CustomFormItem help="Défini si le ticket dans ce statut est résolu ou non (un seul statut peut être à l'étape résolu)"
                label="Resolu"
                name="resolu"
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                valuePropName="checked"
              >
                <Switch />
              </CustomFormItem>
            </Col>
          </Row>

        </Form>
      </Card>
    </Modal>
  );
};

export default StatutCreateForm;

StatutCreateForm.propTypes = {
  visible: PropTypes.bool,
  onCreate: PropTypes.func,
  onCancel: PropTypes.func
};
